import React from "react"

export const ArrowLeft = () => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.171875 5.57812C0.078125 5.71875 0.03125 5.85938 0.03125 6C0.03125 6.1875 0.078125 6.28125 0.171875 6.375L5.70312 11.8125C5.79688 11.9531 5.89062 12 6.07812 12C6.21875 12 6.35938 11.9531 6.5 11.8125L6.82812 11.4844C6.92188 11.3906 6.96875 11.2969 6.96875 11.1094C6.96875 10.9688 6.92188 10.8281 6.82812 10.6875L2.04688 6L6.82812 1.3125C6.92188 1.21875 7.01562 1.07812 7.01562 0.890625C7.01562 0.75 6.92188 0.609375 6.82812 0.515625L6.5 0.140625C6.35938 0.046875 6.21875 0 6.07812 0C5.89062 0 5.79688 0.046875 5.70312 0.140625L0.171875 5.57812Z"
        fill="#232323"
      />
    </svg>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Icons/ArrowLeft.js